import { useContext } from 'react';
import clsx from 'clsx';
import * as R from 'ramda';

import renameIcon from '@atom/components/common/svgIcons/renameIcon.svg';
import WorkTemplateCreationModalContext, {
  ModalView,
} from '@atom/components/common/workTemplateCreationModal/WorkTemplateCreationModalContext';
import WorkTypeFolderTile from '@atom/components/common/workTemplateFolderTree/WorkTypeFolderTile';
import { Icon, Switch, TextField } from '@atom/mui';
import { FolderIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';

import classes from './workTemplateCreationModal.module.css';

const styles = {
  textFieldStyle: {
    marginLeft: '1rem',
    color: colors.neutral.dark,
  },
  icon: {
    marginTop: '1rem',
  },
  switch: {
    width: '440px',
  },
};

const DetailsView = () => {
  const {
    name,
    setName,
    error,
    setError,
    workTemplateFolder,
    setWorkTemplateFolder,
    setActiveView,
    appointmentsEnabled,
    setAppointmentsEnabled,
  } = useContext(WorkTemplateCreationModalContext);

  const handleNameChange = event => {
    setName(event.target.value);
    setError('');
  };

  const switchLabel = (
    <div>
      <div className={classes.labelTitle}>Enable Appointments</div>
      <div className={classes.labelSubtext}>
        {appointmentsEnabled
          ? 'When enabled, Planned Start Date field will appear and require date and time. Due Date will require date and time.'
          : 'When disabled, only Due Date will be shown on work. Due Date is optional and does not require time.'}
      </div>
    </div>
  );

  return (
    <>
      <div className={clsx(classes.modalRow, classes.title)}>Details</div>
      <div className={classes.modalRow}>
        <img style={styles.icon} src={renameIcon} />
        <TextField
          id="name"
          label="Name *"
          value={name}
          onChange={handleNameChange}
          style={styles.textFieldStyle}
          error={!!error}
          helperText={error}
        />
      </div>
      <div className={classes.modalRow}>
        <Icon color={colors.neutral.gray} icon={FolderIcon} />
        {!R.isNil(workTemplateFolder) ? (
          <div className={classes.tileContainer}>
            <WorkTypeFolderTile
              workTemplateFolder={workTemplateFolder}
              removeWorkTemplateFolder={() => setWorkTemplateFolder(null)}
            />
          </div>
        ) : (
          <div
            className={classes.chooseButton}
            onClick={() => setActiveView(ModalView.FOLDER_TREE)}
          >
            Select Folder *
          </div>
        )}
      </div>
      <div className={classes.modalRow}>
        <Switch
          checked={appointmentsEnabled}
          onChange={() => setAppointmentsEnabled(!appointmentsEnabled)}
          label={switchLabel}
          sx={styles.switch}
        />
      </div>
    </>
  );
};

export default DetailsView;
